module.exports = __webpack_public_path__ + "img/business.b4c1a567.png";